import React from 'react'
import { Link } from 'react-router-dom'
import inner from '../../../assets/images/about/arrow-brudcrumb.svg'
import Bgimg from '../../../assets/images/background/chackout-page-bg.jpg'

const PageInear = () => {
    return (
        <>
            <div
                className="page-header-section"
                style={{
                    backgroundImage: `url(${Bgimg})`,
                  }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-8">
                            <div className="page-header-heading">
                                <h2>Checkout</h2>
                                <p className="lead">
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews.
                                </p>
                            </div>
                        </div>
                    </div>
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <img src={inner} alt="icon" />
                        </li>
                        <li>
                            <span>Checkout</span>
                        </li>
                    </ul>
                </div>
            </div>

        </>
    )
}

export default PageInear
